import React, { forwardRef } from 'react';
import { BsChevronDown, BsX } from 'react-icons/bs';
import useDetectClickOut from '../../Utils/useDetectClickOut';

type multiselectProps = {
	selectedRoles: string[];
	setSelectedRoles: (selectedRoles: string[]) => void;
	setIsChanged: (isChanged: boolean) => void;
};

const Multiselect = ({
	selectedRoles,
	setSelectedRoles,
	setIsChanged
}: multiselectProps) => {
	const items = ['user', 'admin', 'editor'];

	// adds new item to multiselect
	const addTag = (item: string) => {
		if (!selectedRoles.includes(item)) {
			setSelectedRoles(selectedRoles.concat(item));
			setIsChanged(true);
		}
	};
	// removes item from multiselect
	const removeTag = (item: any) => {
		const filtered = selectedRoles.filter((e) => e !== item);
		setSelectedRoles(filtered);
		setIsChanged(true);
	};

	const { show, nodeRef, triggerRef } = useDetectClickOut(false);

	return (
		<div className="autcomplete-wrapper">
			<div className="autcomplete">
				<div className="w-full flex flex-col items-center mx-auto">
					<div className="w-full">
						<div className="flex flex-col items-center relative">
							<div className="w-full ">
								<div
									className="my-2 p-1 flex border bg-card-light border-border-light dark:bg-card-dark
											 dark:border-border-dark rounded-lg h-12 transition-all duration-500"
								>
									<div className="flex flex-auto flex-wrap">
										{selectedRoles.map((tag, index) => {
											return (
												<div
													key={index}
													className="flex justify-center items-center m-1 py-1.5 px-1 rounded-full 
                                                            dark:text-gray-800 text-white dark:bg-gray-300
                                                             border dark:border-gray-100 bg-gray-800 transition-all duration-500"
												>
													<div className=" text-xs font-bold leading-none max-w-full flex-initial ml-1">
														{tag}
													</div>
													<div className="flex flex-auto flex-row-reverse">
														<div onClick={() => removeTag(tag)}>
															<BsX
																className="feather feather-x cursor-pointer hover:text-red-500 
                                                                            rounded-full w-4 h-4 ml-1"
															/>
														</div>
													</div>
												</div>
											);
										})}
									</div>
									<div
										className="dark:text-gray-200 text-gray-600 w-8 py-1 pl-2 pr-1 border-l flex 
                                                    items-center border-gray-400 dark:border-gray-500 transition-all duration-500"
										ref={triggerRef}
									>
										<button
											className="cursor-pointer w-6 h-6 dark:text-gray-200 text-gray-600 outline-none 
                                                    focus:outline-none transition-all duration-500"
										>
											<BsChevronDown className=" mx-auto" size={14} />
										</button>
									</div>
								</div>
							</div>
						</div>
						{show && (
							<Dropdown nodeRef={nodeRef} list={items} addItem={addTag} />
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

type dropdownProps = {
	list: any;
	addItem: any;
	nodeRef: any;
};

const Dropdown = forwardRef((props: dropdownProps) => {
	return (
		<div
			id="dropdown"
			ref={props.nodeRef}
			className="absolute top-100 border-gray-200 dark:border-gray-900 shadow-md  
                    bg-gray-300 dark:bg-gray-700  z-40 lef-0 max-h-select overflow-y-auto w-60 rounded-lg"
		>
			<div className="flex flex-col w-full">
				{props.list.map((item: any, key: any) => {
					return (
						<div
							key={key}
							className="cursor-pointer w-full dark:text-gray-400 text-gray-800 border-gray-100 
                                    dark:border-gray-800 rounded-t border-b hover:bg-gray-400 dark:hover:bg-gray-600 
                                    transition-all duration-500"
							onClick={() => props.addItem(item)}
						>
							<div
								className="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative
                                         hover:bg-gray-400 dark:hover:bg-gray-600"
							>
								<div className="w-full items-center flex">
									<div className="mx-2 leading-6">{item}</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
});

export default Multiselect;
